import React from "react";
import "./notFound.css";
import Img404NotFound from "../../assets/images/notFoundImg.png";
import ImgRunnerNotFound from "../../assets/images/runerNotFound.png";
import LogotipoRadaria from "../../assets/images/logotipos/RADARIA-LOGOTIPO04.png";
import { FaArrowCircleLeft } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const NotFound = () => {
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  const { userType } = useSelector((state) => state.userReducer);
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1); // Vuelve a la ruta anterior si hay historial
    } else {
      // Si no hay historial, redirige a la ruta por defecto
      navigate(
        isAuthenticated
          ? userType === "user"
            ? "/dashboard/history"
            : "/dashboard-provider/list-patients"
          : "/",
        { replace: true }
      );
    }
  };
  return (
    <div className="continer-not-found">
      <article className="d-flex flex-column container-message-notfound">
        <div>
          <button
            onClick={handleGoBack}
            className="d-flex gap-3 btn-go-back btn"
          >
            <FaArrowCircleLeft className="text-white fs-1" />
            <img src={LogotipoRadaria} alt="" width={200} height={40} />
          </button>
        </div>
        <div className="wrap-message">
          <h2 className="text-white text-center">Oops!</h2>
          <h3 className="text-white text-center">
            Parece que no podemos encontrar la página que estás buscando.
          </h3>
          <img src={ImgRunnerNotFound} alt="" />
        </div>
      </article>
      <article className="container-img-not-found">
        <img src={Img404NotFound} alt="" />
      </article>
    </div>
  );
};

export default NotFound;
